<span class="pgroup-name-array-name">{{ applianceName }}</span> /
<span *ngIf="podName"
    ><span class="prgroup-name-pod-name">{{ podName }}</span> /</span
>
<span class="pgroup-name-name">{{ pgroupName }}</span>
